/** Global mission indices for the Kendrex Colony map surface (`shadowverse_kendrex.jpg`). */
export const EXPLORE_UNKNOWN_KENDREX_COLONY_FIRST_MISSION_INDEX = 41;
export const EXPLORE_UNKNOWN_KENDREX_COLONY_LAST_MISSION_INDEX = 46;
export const EXPLORE_UNKNOWN_KENDREX_COLONY_SURFACE = 'kendrex';

/**
 * @param {unknown} missionIndex
 * @returns {boolean}
 */
export function isExploreUnknownKendrexColonyMissionIndex(missionIndex) {
  const idx = Number(missionIndex);
  return (
    Number.isInteger(idx) &&
    idx >= EXPLORE_UNKNOWN_KENDREX_COLONY_FIRST_MISSION_INDEX &&
    idx <= EXPLORE_UNKNOWN_KENDREX_COLONY_LAST_MISSION_INDEX
  );
}

/**
 * @param {unknown} surface
 * @returns {boolean}
 */
export function isExploreUnknownKendrexColonySurface(surface) {
  return surface === EXPLORE_UNKNOWN_KENDREX_COLONY_SURFACE;
}
